
import { defineStore } from 'pinia'
import { ref } from "vue";
export const useHostConfigStore = defineStore('hostConfigStore', () => {
    let host_domain = import.meta.env.VITE_HOST_DOMAIN;
    let host_protocol = import.meta.env.VITE_HOST_PROTOCOL;
    let host_protocol_ws = import.meta.env.VITE_HOST_PROTOCOL_WS;
    let host_port = import.meta.env.VITE_HOST_PORT

    let domain_new = "zelostech.com.cn";
    let domain_type = 'zelostech.com.cn';//localhost playback // 1. uat 其他;

    let host_config = ref({
        VITE_LOGIN_REDIRECT: `https://playback.zelostech.com.cn/`,
        VITE_GATEWAY_HOST: 'https://gateway.zelostech.com.cn/',
        VITE_GATEWAY_HOST_BJ: 'https://gateway-volcbj1.zelostech.com.cn/',
        VITE_AUTH_HOST: 'https://auth.zelostech.com.cn',
        VITE_DATA_PUB_HOST: 'https://gateway-data-pub.zelostech.com.cn',
        VITE_NODE_HOST: 'wss://gateway.zelostech.com.cn/playback-server/data_session_client',
        VITE_NODE_HOST_BJ: 'wss://gateway-volcbj1.zelostech.com.cn/playback-server/data_session_client',
        VITE_AUTH_HOST_UAT: 'https://auth-uat.zelostech.com.cn',
        VITE_GATEWAYDATA_HOST: 'https://gateway-data-pub.zelostech.com.cn/',
        // 数据中心 dap-server（获取车辆最近一次远程控制记录等）
        VITE_DATACENTER_HOST: 'https://datacenter.zelostech.com.cn',
    })
    // let host_config = ref({
    //     VITE_LOGIN_REDIRECT: `https://playback-uat.zelostech.com.cn/`,
    //     VITE_GATEWAY_HOST: 'https://gateway-uat.zelostech.com.cn/',
    //     VITE_GATEWAY_HOST_BJ: 'https://gateway-volcbj1.zelostech.com.cn/',
    //     VITE_AUTH_HOST: 'https://auth-uat.zelostech.com.cn',
    //     VITE_DATA_PUB_HOST: 'https://gateway-data-pub-uat.zelostech.com.cn',
    //     VITE_NODE_HOST: 'wss://gateway-uat.zelostech.com.cn/playback-server/data_session_client',
    //     VITE_NODE_HOST_BJ: 'wss://gateway-volcbj1.zelostech.com.cn/playback-server/data_session_client'
    // })


    function setConfig(config: any) {
        host_domain = config.host_domain
        host_protocol = config.host_protocol
        host_port = config.host_port
        host_protocol_ws = config.host_protocol_ws
        domain_new = formatDomain(host_domain);
        build_host_config()
        host_config.value.VITE_LOGIN_REDIRECT = config.origin + "/"
        console.log('host', config, host_config);
    }
    function formatDomain(domain: string) {
        let arr = domain.split('.')
        let f_host = arr.shift();
        if (f_host?.includes('-')) {
            domain_type = f_host.split("-")[1];
        }
        if (f_host?.includes('localhost')) {
            domain_type = 'localhost';
        }
        return arr.join('.');
    }    
    function build_host_config() {
        if (domain_type == 'localhost') return;
        if (domain_type == 'zelostech.com.cn') {
            host_config.value.VITE_GATEWAY_HOST = host_config.value.VITE_GATEWAY_HOST.replace('https', host_protocol);
            host_config.value.VITE_GATEWAY_HOST = host_config.value.VITE_GATEWAY_HOST.replace('zelostech.com.cn', domain_new);

            host_config.value.VITE_AUTH_HOST = host_config.value.VITE_AUTH_HOST.replace('https', host_protocol);
            host_config.value.VITE_AUTH_HOST = host_config.value.VITE_AUTH_HOST.replace('zelostech.com.cn', domain_new);

            host_config.value.VITE_DATA_PUB_HOST = host_config.value.VITE_DATA_PUB_HOST.replace('https', host_protocol);
            host_config.value.VITE_DATA_PUB_HOST = host_config.value.VITE_DATA_PUB_HOST.replace('zelostech.com.cn', domain_new);

            host_config.value.VITE_NODE_HOST = host_config.value.VITE_NODE_HOST.replace('wss', host_protocol_ws);
            host_config.value.VITE_NODE_HOST = host_config.value.VITE_NODE_HOST.replace('zelostech.com.cn', domain_new);

            host_config.value.VITE_DATACENTER_HOST = host_config.value.VITE_DATACENTER_HOST.replace('https', host_protocol);
            host_config.value.VITE_DATACENTER_HOST = host_config.value.VITE_DATACENTER_HOST.replace('zelostech.com.cn', domain_new);
        }else{
            // -uat
            host_config.value.VITE_GATEWAY_HOST = host_config.value.VITE_GATEWAY_HOST.replace('https', host_protocol);
            host_config.value.VITE_GATEWAY_HOST = host_config.value.VITE_GATEWAY_HOST.replace('gateway', `gateway-${domain_type}`);

            host_config.value.VITE_AUTH_HOST = host_config.value.VITE_AUTH_HOST.replace('https', host_protocol);
            host_config.value.VITE_AUTH_HOST = host_config.value.VITE_AUTH_HOST.replace('auth', `auth-${domain_type}`);

            host_config.value.VITE_DATA_PUB_HOST = host_config.value.VITE_DATA_PUB_HOST.replace('https', host_protocol);
            host_config.value.VITE_DATA_PUB_HOST = host_config.value.VITE_DATA_PUB_HOST.replace('gateway-data-pub', `gateway-data-pub-${domain_type}`);

            host_config.value.VITE_NODE_HOST = host_config.value.VITE_NODE_HOST.replace('wss', host_protocol_ws);
            host_config.value.VITE_NODE_HOST = host_config.value.VITE_NODE_HOST.replace('gateway', `gateway-${domain_type}`);

            host_config.value.VITE_DATACENTER_HOST = host_config.value.VITE_DATACENTER_HOST.replace('https', host_protocol);
            host_config.value.VITE_DATACENTER_HOST = host_config.value.VITE_DATACENTER_HOST.replace('datacenter', `datacenter-${domain_type}`);
        }
    }
    return {
        setConfig,
        host_config
    }
})